/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Indicates the field to use for sorting the data:
 *   * NAME : the diffusion list's name
 */
export enum DiffusionListSortFieldName {
  NAME = 'NAME'
}
